import { render, staticRenderFns } from "./GraficoComissao.vue?vue&type=template&id=36e33ca3&"
import script from "./GraficoComissao.vue?vue&type=script&lang=ts&"
export * from "./GraficoComissao.vue?vue&type=script&lang=ts&"
import style0 from "./GraficoComissao.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports